import React, { useState } from 'react';
import Homepage from './pages/Homepage';
import Formulaire from './pages/Formulaire';
import Admin from './pages/Admin';
import AdminLogin from './pages/AdminLogin';
import ModifierTemoignage from './pages/ModifierTemoignage';
import PageStatistiques from './pages/PageStatistiques';
import CGU from './pages/CGU';
import ComingSoon from './pages/ComingSoon';
import MonCompte from './pages/MonCompte';
import PageFiches from './pages/PageFiches';
import PageCarte from './pages/PageCarte';
import PageEnConstruction from './pages/PageEnConstruction';
import { supabase } from './supabase';
import './App.css';

export default function App() {
  const [page, setPage] = useState(window.location.hash.includes('access_token') ? 'compte' : 'home');

  const [adminToken, setAdminToken] = useState(localStorage.getItem('recensement_token'));
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedFicheId, setSelectedFicheId] = useState(null);
  const [sessionUser, setSessionUser] = useState(null);

  React.useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => setSessionUser(session?.user || null));
    supabase.auth.onAuthStateChange((_e, session) => setSessionUser(session?.user || null));
  }, []);

  const goDeposer = () => sessionUser ? navigate('compte') : navigate('formulaire');
  const [showComingSoon, setShowComingSoon] = useState(false);

  const navigate = (p) => { setPage(p); window.scrollTo(0, 0); setMenuOpen(false); };
  const logout = () => { localStorage.removeItem('recensement_token'); setAdminToken(null); navigate('home'); };

  React.useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN' && session) navigate('compte');
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <div className="app">
      {showComingSoon && <ComingSoon onClose={() => setShowComingSoon(false)} />}
      <div style={{background:'#1a7fd4',color:'#fff',textAlign:'center',padding:'7px',fontSize:'11px',letterSpacing:'0.06em',fontWeight:'500'}}>
        VERSION BÊTA — SITE EN CONSTRUCTION · Ouverture officielle le 10 juillet 2026
      </div>
      <header className="hdr" style={{background:"#fff",borderBottom:"1px solid #eee",padding:"14px 32px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div className="logo-wrap" onClick={() => navigate('home')} style={{cursor:'pointer',lineHeight:'1.2'}}>
          <span className="logo-mobile" style={{fontSize:"22px",fontWeight:"900",letterSpacing:"-0.02em",lineHeight:"1"}}><span style={{color:"#19232F"}}>RE</span><span style={{color:"#065FD3"}}>NP</span></span>
          <span className="logo-desktop"><div style={{fontSize:"12px",fontWeight:"800",color:"#19232F",textTransform:"uppercase",letterSpacing:"0.02em"}}>Recensement des enfants</div><div style={{fontSize:"22px",fontWeight:"900",color:"#065FD3",textTransform:"uppercase"}}>Non-Protégés</div></span>
        </div>
        <nav className={`nav${menuOpen ? ' open' : ''}`}>
          {menuOpen && <button onClick={() => setMenuOpen(false)} style={{position:"fixed",top:"16px",right:"20px",background:"none",border:"none",fontSize:"28px",cursor:"pointer",zIndex:300,color:"#19232F"}}>✕</button>}
          <a onClick={() => navigate('statistiques')}>Statistiques</a>
          <a onClick={() => navigate('carte')}>Carte</a>
          <a onClick={() => navigate('actualites')}>Actualités</a>
          <a onClick={() => navigate('fiches')}>Fiches</a>
          {adminToken
            ? <><a onClick={() => navigate('admin')}>Admin</a><a onClick={logout}>Déconnexion</a></>
            : <a onClick={() => navigate('admin-login')}>Admin</a>
          }
        </nav>
        <div style={{display:"flex",gap:"8px",alignItems:"center"}}>
          <button style={{border:"1.5px solid #19232F",borderRadius:"999px",padding:"6px 16px",fontSize:"11px",fontWeight:"600",color:"#19232F",background:"#fff",cursor:"pointer"}} onClick={() => navigate('compte')} className="btn-connect">SE CONNECTER</button>
          <button style={{border:"none",borderRadius:"999px",padding:"7px 18px",fontSize:"11px",fontWeight:"700",color:"#fff",background:"#065FD3",cursor:"pointer"}} onClick={goDeposer} className="btn-deposit desktop-only">RENSEIGNER UNE FICHE</button>
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>☰</button>
        </div>
      </header>

      {page === 'home' && <Homepage onDeposer={() => navigate('formulaire')} onNavigate={navigate} onOpenFiche={(id) => { setSelectedFicheId(id); navigate('fiches'); }} />}
      {page === 'formulaire' && <Formulaire onBack={() => navigate('home')} onNavigate={() => navigate('compte')} />}
      {page === 'admin-login' && <AdminLogin onLogin={(t) => { setAdminToken(t); navigate('admin'); }} />}
      {page === 'admin' && adminToken && <Admin token={adminToken} onLogout={logout} />}
      {page === 'modifier' && <ModifierTemoignage onBack={() => navigate('home')} />}
      {page === 'cgu' && <CGU onBack={() => navigate('home')} />}
      {page === 'compte' && <MonCompte onBack={() => navigate('home')} onDeposer={() => navigate('formulaire')} />}
      {page === 'fiches' && <PageFiches onBack={() => navigate('home')} selectedFicheId={selectedFicheId} onClearFiche={() => setSelectedFicheId(null)} />}
      {page === 'statistiques' && <PageStatistiques />}
      {page === 'carte' && <PageCarte />}
      {page === 'actualites' && <PageEnConstruction />}
    </div>
  );
}
